import React, { useEffect, useState } from "react";
import { Container } from "./styled";
import { calculatePercj } from "../../lib/cabbStats";
const TeamInformation = ({
  teamId,
  games,
  activeSeason,
  activePhase,
  isDNDTool,
}) => {
  const [seasonGames, setSeasonGames] = useState(null);

  useEffect(() => {
    if (teamId !== null) {
      let activeGames = [];
      games?.forEach((element) => {
        if (
          element.season === activeSeason &&
          (activePhase === null || element.stage === activePhase) &&
          (element.local_team === teamId || element.visit_team === teamId)
        ) {
          activeGames.push(element);
        }
      });
      setSeasonGames(activeGames);
    }
  }, [teamId, activePhase, activeSeason, games]);

  return (
    <Container isDNDTool={isDNDTool}>
      <div className="standing-chart-header flex_center_space-between">
        <p className="title">Rendimiento del equipo</p>
      </div>
      <div className="info-container-extra">
        <div className="info-container">
          <p className="title">Posesiones Por Partido</p>
          <p className="subtext">POSS</p>
          <h3>{calculatePercj(seasonGames, teamId, "POSS").toFixed()}</h3>
        </div>
        <div className="info-container">
          <p className="title">Puntos por posesión</p>
          <p className="subtext">PPP</p>
          <h3>{calculatePercj(seasonGames, teamId, "PPP").toFixed(1)}</h3>
        </div>
        <div className="info-container">
          <p className="title">Efectividad tiros de campo</p>
          <p className="subtext">eFG%</p>
          <h3>{calculatePercj(seasonGames, teamId, "eFG")}%</h3>
        </div>
        <div className="info-container">
          <p className="title">Tasa de perdidas</p>
          <p className="subtext">TOR</p>
          <h3>{calculatePercj(seasonGames, teamId, "TOR")}%</h3>
        </div>
        <div className="info-container">
          <p className="title">Rebotes ofensivos</p>
          <p className="subtext">OREB</p>
          <h3>{calculatePercj(seasonGames, teamId, "OREB")}%</h3>
        </div>
        <div className="info-container">
          <p className="title">Tasa de tiros libres</p>
          <p className="subtext">FTR</p>
          <h3>{calculatePercj(seasonGames, teamId, "FTR")}%</h3>
        </div>
      </div>
    </Container>
  );
};

export default TeamInformation;
